import {
  useQuery,
} from 'react-query';

import { useMiddleman, getCurrentMiddleman } from 'helpers/MiddlemanContext';

export const useFormFiles = (tags: string[], page: number) => {
  const middleman = useMiddleman();

  return useQuery(['form_files', tags, page], () => {
    return middleman.get(
      `/v1/file/terms?filter[tags.name]=${tags.join(',')}&page=${page}`
    ).then((response) => {
      return response.data;
    });
  }, { enabled: !!tags, refetchOnWindowFocus: false });
};